import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { routes, getContextDashboardRoute, appConfig } from '@/lib/config'
import { getProfile } from '@/lib/services/profiles'
import { getUserUnits, setCurrentUnit } from '@/lib/services/units'
import { useUnit } from '@/contexts/UnitContext'

export default function Dashboard() {
  const navigate = useNavigate()
  const { user: authUser, loading: authLoading } = useAuth()
  const { contextKey, isLoading: unitLoading } = useUnit()

  useEffect(() => {
    // Wait for both auth and unit context to finish loading before doing anything
    if (authLoading || unitLoading) return

    const redirect = async () => {
      if (!authUser) {
        navigate(routes.login, { replace: true })
        return
      }

      // Se há contexto fixo no .env, redireciona direto sem verificar onboarding de outras units
      if (appConfig.fixedContext) {
        const target = getContextDashboardRoute(appConfig.fixedContext)
        navigate(target, { replace: true })
        return
      }

      try {
        // Check if user has units AND profile
        const units = await getUserUnits(authUser.id)
        const userProfile = await getProfile(authUser.id)
        
        const hasUnits = units && units.length > 0
        const hasProfile = userProfile && userProfile.full_name

        // If missing units or profile, go to onboarding
        if (!hasUnits || !hasProfile) {
          navigate('/onboarding', { replace: true })
          return
        }

        if (!userProfile?.current_unit_id && units.length > 0) {
          await setCurrentUnit(authUser.id, units[0].id)
          // After setting the current unit, UnitContext will reload (unitLoading will toggle).
          // The effect will re-run once unitLoading becomes false again — do not redirect now.
          return
        }
      } catch (error) {
        console.error('Dashboard - Erro ao verificar unidades e perfil:', error)
      }

      const target = getContextDashboardRoute(contextKey)
      // Avoid redirect loop if already on /dashboard and no context found
      if (target !== '/dashboard') {
        navigate(target, { replace: true })
      }
    }

    redirect()
  }, [authUser, authLoading, contextKey, unitLoading, navigate])

  return (
    <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-green-600 border-r-transparent"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-400">Carregando...</p>
      </div>
    </div>
  )
}


